import { GUT_BODY_CONNECTIONS_COPY } from '@repo/ui';
import {
  BetaTag,
  Card,
  CardErrorBoundaryWithSpinfinity,
  Typography,
} from 'components';
import { useTrackImpression } from 'contexts/analytics/useTrackImpression';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import BodyContainer from './BodyContainer';
import styles from './GutBodyConnectionsCard.module.css';
import OrganList from './OrganList';

export default function GutBodyConnectionsCard() {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const impressionRef = useTrackImpression(
    'Conditions Module Seen In Results Page',
    currentKit ? currentKitId : undefined,
    { experience: 'gut_body_connections' },
  );

  return (
    <CardErrorBoundaryWithSpinfinity cardName='GutBodyConnectionsCard'>
      <Card>
        <div ref={impressionRef} className={styles.cardContainer}>
          <div className='flex align-items-center gap-1'>
            <Typography variant='heading-m'>
              {GUT_BODY_CONNECTIONS_COPY.title}
            </Typography>
            <BetaTag />
          </div>
          <Typography variant='caption' color='grey'>
            {GUT_BODY_CONNECTIONS_COPY.subtitle}
          </Typography>
          <BodyContainer />
          <OrganList />
        </div>
      </Card>
    </CardErrorBoundaryWithSpinfinity>
  );
}
